import React, { useEffect, useState, useContext, useMemo } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { NewDropdownQuestion, NewDropdownOption } from "../../common_components/Forms";
import TimeGrid from "./TimeGrid";
import TimezoneList from "../../../../../user_portal/preauth_portal/components/TimezoneList";
import { useAlert } from 'react-alert'
import LoadingIcon from "../../common_components/LoadingIcon";

// API Calls

function AvailabilityCalendar(props) {

    const schedulingNoticeTooltip = "The earliest a new session can be scheduled. E.g. 24 hours means all sessions must be scheduled at least 24 hours in the future."
    const bufferToolTip = "The minimum time between the end of one session and the start of another."

    useEffect(() => {
        // Enable tooltips
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
    }, [props.loadingMissionEvent]);

    return (
        <>
            {props.loadingMissionEvent ? <LoadingIcon /> :
                <>
                    <div className="time-grid-and-dropdown-container">
                        <div className="legend-and-timezone-container">
                            <div className="scheduling-dropdown-container">
                                <div className="scheduling-dropdown-question-container">
                                    <NewDropdownQuestion questionText="Minimum Scheduling Notice" name="notice" id="notice" onChange={props.onChangeNotice} value={props.notice} tooltip={schedulingNoticeTooltip} whiteText={true}>
                                        <NewDropdownOption value={24}>24 hours</NewDropdownOption>
                                        <NewDropdownOption value={48}>48 hours</NewDropdownOption>
                                    </NewDropdownQuestion>
                                </div>
                                <div className="scheduling-dropdown-question-container">

                                    <NewDropdownQuestion questionText="Minimum Buffer Between Meetings" name="buffer" id="buffer" onChange={props.onChangeBuffer} value={props.buffer} tooltip={bufferToolTip} whiteText={true}>
                                        <NewDropdownOption value={15}>15 minutes</NewDropdownOption>
                                        <NewDropdownOption value={30}>30 minutes</NewDropdownOption>
                                        <NewDropdownOption value={45}>45 minutes</NewDropdownOption>
                                        <NewDropdownOption value={60}>1 hour</NewDropdownOption>
                                    </NewDropdownQuestion>
                                </div>
                                <div className="scheduling-dropdown-question-container">

                                    <NewDropdownQuestion questionText="Timezone" name="tz" id="tz" onChange={props.onChangeTimezone} value={props.timezone} whiteText={true}>
                                        {TimezoneList.map((tz) => <NewDropdownOption key={tz} value={tz}>{tz}</NewDropdownOption>)}
                                    </NewDropdownQuestion>
                                </div>
                            </div>
                        </div>
                        <TimeGrid timezone={props.timezone}
                            selectedSlots={props.selectedSlots}
                            setSelectedSlots={props.setSelectedSlots}
                            missionLength={props.missionLength}
                        />
                    </div>
                </>
            }
        </>

    )
}






export default AvailabilityCalendar;
